import clsx from "clsx";

import { Border } from "../components/Border";
import { FadeIn, FadeInStagger } from "../components/FadeIn";

export function List({ children, className }) {
  return (
    <FadeInStagger>
      <ul role="list" className={clsx("text-base text-neutral-600", className)}>
        {children}
      </ul>
    </FadeInStagger>
  );
}

export function ListItem({ children, title }) {
  return (
    <li className="group mt-5 first:mt-0 ">
      <FadeIn>
        <Border className="pt-2 pb-2 group-first:pt-0 group-first:before:hidden group-first:after:hidden"></Border>
        <div className="hover:bg-neutral-100  hover:cursor-pointer text-neutral-950 transition-color ease-in-out duration-100  py-5 px-3 rounded-3xl  ">
          {title && (
            <strong className="font-semibold  ">{`${title}. `}</strong>
          )}
          {children}
        </div>
      </FadeIn>
    </li>
  );
}
